import { render } from "./AppTable.vue?vue&type=template&id=f1ad5968&scoped=true"
import script from "./AppTable.vue?vue&type=script&lang=js"
export * from "./AppTable.vue?vue&type=script&lang=js"

import "./AppTable.vue?vue&type=style&index=0&id=f1ad5968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ad5968"]])

export default __exports__